import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {environment} from '../environments/environment';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getFirestore, provideFirestore} from '@angular/fire/firestore';
import {getAuth, provideAuth} from '@angular/fire/auth';
import { LoginComponent } from './login/login.component';
import { NewListComponent } from './new-list/new-list.component';
import { ListOverviewComponent } from './list-overview/list-overview.component';
import { ShoppingListComponent } from './shopping-list/shopping-list.component';
import {ReactiveFormsModule} from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CategorySelectorComponent } from './ingredients/category-selector/category-selector.component';
import { IngredientsListComponent } from './ingredients/ingredients-list/ingredients-list.component';
import {AuthGuard} from './auth/auth.guard';
import {AuthService} from './auth/auth.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NewListComponent,
    ListOverviewComponent,
    ShoppingListComponent,
    CategorySelectorComponent,
    IngredientsListComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FontAwesomeModule
  ],
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    AuthGuard,
    AuthService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
